import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AUTH_ROUTES } from './auth/auth.routes';

export const APP_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('./home/home.component').then(c => c.HomeComponent),
        canActivate: [MsalGuard]
    },
    ...AUTH_ROUTES
];
